import { authorization } from '../../../../Module/Auth/Auth'
import { callAuthorizedGraphQLEndpoint } from '../../../../Module/graphQL'
import { MISSION_STATUS_ENUM } from '../../../../shared/constants'

/**
 * Gets the data for master schedule screen export.
 * @param {number} campaignId
 */
export const getMasterScheduleExportData = async campaignId => {
  const query = `query ($campaignId:ID!, $statuses:[MissionStatusEnum]) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            missions(statuses: $statuses) {
              edges {
                node {
                  id
                  flyerCode
                  status
                  totalFlyersDistributed
                  dateTime
                  distributionCost
                  printingCostPerFlyerV2
                  packSize
                  bonusPerConversion
                  bonusRedemptionPeriod
                  type
                  flyerCodeV2 {
                    tag
                    code
                  }
                  user {
                    firstName
                    lastName
                  }
                  location {
                    id
                    name
                    hasPermit
                    type {
                      name
                    }
                  }
                  metricResults {
                    nodes {
                      id
                      value
                      metric {
                        id
                        name
                      }
                    }
                  }
                  conversions {
                    nodes {
                      id
                      timestamp
                      metric {
                        isPrimary
                      }
                    }
                  }
                  label
                  amountScans
                }
              }
            }
            city {
              name
              lunchCheckInTime
              afternoonCheckInTime
            }
            permitCosts {
              nodes {
                startDate
                cost
              }
            }
          }
        }
      }
    }`

  // If user is a client - hide cancelled mission
  const statuses = authorization.isClient()
    ? [
        MISSION_STATUS_ENUM.UNDER_REVIEW,
        MISSION_STATUS_ENUM.COMPLETED,
        MISSION_STATUS_ENUM.PAID,
      ]
    : [
        MISSION_STATUS_ENUM.UNDER_REVIEW,
        MISSION_STATUS_ENUM.COMPLETED,
        MISSION_STATUS_ENUM.PAID,
        MISSION_STATUS_ENUM.CANCELLED,
      ]

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    statuses,
  })
  return response.json()
}

/**
 * Gets the data for master schedule screen export.
 * @param {number} campaignId
 */
export const getMasterScheduleData = async ({ campaignId, ...params }) => {
  const query = `query 
  (
    $campaignId:ID!
    $first: Int
    $after: String
    $locationId:ID
    $cityId:ID
    $statusAndAbove: MissionStatusEnum
    $statusAndBelow: MissionStatusEnum
    $timeOfDay: MissionTimeOfDayEnum
    $filter:String
    $orderBy:MissionOrderByEnum
    $dayOfTheWeek:DayOfTheWeekEnum
    $startDate:String
    $endDate:String
    ) {
      campaign(id:$campaignId){
        missions(
          first: $first,
          after: $after
          locationId: $locationId
          statusAndAbove: $statusAndAbove
          statusAndBelow: $statusAndBelow
          timeOfDay: $timeOfDay
          filter: $filter
          orderBy: $orderBy
          dayOfTheWeek: $dayOfTheWeek
          startDate: $startDate
          endDate: $endDate
          cityId: $cityId
          ) {
          totalCount
          edges {
            node {
              id
              flyerCode
              status
              totalFlyersDistributed
              dateTime
              distributionCost
              packSize
              printingCostPerFlyer
              type
              timeOfDay
              flyerCodeV2 {
                tag
                code
              }
              cityPlan {
                city {
                  name
                  lunchCheckInTime
                  afternoonCheckInTime
                  timezone
                }
              }
              user {
                id
                firstName
                lastName
              }
              location {
                id
                name
                type {
                  name
                }
              }
              metricResults {
                nodes {
                  id
                  value
                  metric {
                    id
                    name
                  }
                }
              }
              label
              amountScans
              spyInformation{
                spy{
                  id
                  firstName
                  lastName
                }
                spyDetails{
                  checkInTime
                  checkoutTime
                  reportReason
                  }
                shift{
                  id
                }
              }
            }
          }
        }
        cityPlans {
          nodes {
            id
            city {
              id
              name
              lunchCheckInTime
              afternoonCheckInTime
              timezone
              locations {
                edges {
                  node {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
    ...params,
  })
  return response.json()
}

/**
 * Gets the data for master schedule missions import.
 * @param {number} campaignId
 */
export const getDataForMissionsImport = async campaignId => {
  const query = `query ($campaignId:ID!) {
      campaign(id:$campaignId){
        cityPlans {
          nodes {
            city {
              brandAmbassadors {
                edges {
                  node {
                    id
                    firstName
                    lastName
                  }
                }
              }
            }
          }
        }
      }
    }`

  const response = await callAuthorizedGraphQLEndpoint(query, {
    campaignId,
  })
  return response.json()
}



// WEBPACK FOOTER //
// ./src/Containers/Campaigns/Page/MasterSchedule/gql.js